module.exports = "/assets/js/21d650148542825ec998c09efbe89e9b.svg";